import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

const ChatMessage = (props) => (
	<Col xs={12} md={12}>
	    <Row>
	      <Col xs={12} md={6} className="sender">
	        <div className="bubble round">
	          <div className="talktext tri-right left-top">
	            <p className="txt">{props.message}</p>
	          </div>
	        </div>
	      </Col>
	    </Row>
	</Col>
);

export default ChatMessage;


// WEBPACK FOOTER //
// ./src/ChatMessage.js